import { useState } from 'react'
import styled from '@emotion/styled'
import { Link } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Typography from '@mui/material/Typography'
import { Text } from '@components/dataset/approvalDetails/styles'
import { AccountFieldManager, AuthFieldType } from '../components'
import { t } from '@lingui/core/macro'
import { AccountType } from '../types'
import { isNumeric } from 'utils/identifiers'

interface GoogleAdsProps {
  newConnection: boolean
  updatedAccount: AccountType
  setRequiredFieldMissing: (fieldsMissing: boolean) => void
  setUpdatedAccount: (updatedAccount: AccountType) => void
}

const FlexRadioInline = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
`
export const GoogleAds = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  newConnection,
}: GoogleAdsProps) => {
  const { customer_id } = updatedAccount.metadata
  const [radioButtonValue, setRadioButtonValue] = useState('')

  const GoogleAdsFields: AuthFieldType[] = [
    {
      fieldValue: typeof customer_id !== 'undefined' ? String(customer_id) : customer_id,
      fieldKey: 'customer_id',
      fieldLabel: t`Customer ID`,
      description: t`The customer ID of the account that you will be connecting to Claravine.`,
      errorText: t`Customer ID must only contain numbers.`,
      hasError: !!(customer_id && isNaN(customer_id)),
    },
  ]

  return (
    <div>
      <FlexRadioInline
        value={radioButtonValue}
        onChange={event => {
          setRadioButtonValue(event.target.value)
        }}
      >
        <FormControlLabel
          value={t`Customer ID`}
          control={<Radio />}
          onChange={e => {
            const value = (e as React.ChangeEvent<HTMLInputElement>).target.value
            let customer_id: number | undefined
            if (isNumeric(value)) {
              customer_id = Number(value)
            }
            setUpdatedAccount({
              ...updatedAccount,
              metadata: { ...updatedAccount.metadata, customer_id: customer_id },
            })
          }}
          label={
            <Text>
              {t`I acknowledge Claravine's use and transfer to any other app of information received
              from Google APIs will adhere to Google API Services User Data Policy:`}
              <span>
                <Link
                  href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                >
                  {' '}
                  {t`including the Limited Use requirements.`}
                </Link>
              </span>
            </Text>
          }
        />
      </FlexRadioInline>
      {radioButtonValue ? (
        <AccountFieldManager
          newConnection={newConnection}
          updatedAccount={updatedAccount}
          setUpdatedAccount={setUpdatedAccount}
          accountFields={GoogleAdsFields}
          setRequiredFieldsMissing={setRequiredFieldMissing}
        />
      ) : (
        <Typography color="error">{t`Please agree to the terms before proceeding.`}</Typography>
      )}
    </div>
  )
}
